import { connect } from 'react-redux';
import { IState } from '../../reducers';
import { fetchArchivePageNewsItemsAction, fetchArchivePageNewsItemsByCategoryAction, fetchNewsCategoriesAction } from './actions/fetchArchivePageNewsItems';

import {ArchiveNewsPage} from './archiveNewsPage';

const mapStateToProps = (state: IState, ownProps: any) => ({
    categoriesFilter: ownProps.params.categories,
    newsCategories: state.eventsAndNewsItems.newsCategories,
    newsItemDto: state.eventsAndNewsItems.newsItemDto
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchArchivePageNews: (query?: object) => dispatch(fetchArchivePageNewsItemsAction(query)),
    fetchArchivePageNewsItemsByCategory: (categories: string, query?: object) => dispatch(fetchArchivePageNewsItemsByCategoryAction(categories, query)),
    fetchNewsCategories: () => dispatch(fetchNewsCategoriesAction())
});

export const ArchiveNewsPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArchiveNewsPage);


// WEBPACK FOOTER //
// ./src/components/archiveNewsPage/archiveNewsPageContainer.tsx